<template>
  <div>
    <div class="card mt-1">
      <div class="card-body">
        <div class="card-title">
          <h3>{{ currentStaff.full_name }} requests</h3>
        </div>
        <!-- Date range filter -->
        <div class="row my-3">
          <div class="col">
            <payment-request-date-filter :start-date="startDate" :end-date="endDate" @update-date-range="updateDateRange" />

            <div v-if="loadingRequests" class="spinner-grow text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <div class="col d-flex align-items-center gap-2">
            <label class="form-label text-uppercase small text-muted fw-semibold mb-0" for="credit-type-filter">Credit Type</label>
            <select id="credit-type-filter" v-model="creditType" class="form-select form-select-sm" :class="{ 'border-active': creditType !== '__all__' }">
              <option value="__all__">
                All credits
              </option>
              <option value="normal">
                Project
              </option>
              <option value="head_hunting">
                Headhunting
              </option>
            </select>
          </div>
          <div class="col">Total Credits: {{ totalCredits }}</div>
        </div>
        <!-- eof Date range filter -->

        <payment-request-list-table :is-admin="isAdmin" :request-list="filteredRequests" :editable="editable" :start-date="startDate" :end-date="endDate" @fetch-requests="fetchRequests(staffId)" />
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import moment from "moment-timezone";
import { mapGetters } from "vuex";
import PaymentRequestListTable from "./elements/PaymentRequestListTable.vue";
import PaymentRequestDateFilter from "./elements/PaymentRequestDateFilter.vue";

export default {
  name: "StaffProjectListTable",
  components: { PaymentRequestDateFilter, PaymentRequestListTable },
  props: {
    staffId: {
      type: Number,
      required: false,
      default: 0,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    startDate: {
      type: String,
      required: false,
      default: "",
    },
    endDate: {
      type: String,
      required: false,
      default: "",
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      creditType: "__all__",
      loadingRequests: false,
      currentDate: new Date(),
      range: {
        start: this.startDate !== "" && moment(this.startDate).isBefore(moment(this.endDate)) ? this.startDate : moment().startOf("month").format("YYYY-MM-DD"),
        end: this.endDate !== "" && moment(this.endDate).isAfter(moment(this.startDate)) ? this.endDate : moment().endOf("month").format("YYYY-MM-DD"),
      },
      modelConfig: {
        end: {
          timeAdjust: "23:59:59",
        },
      },
    };
  },
  computed: {
    filteredRequests() {
      if (this.creditType === "__all__") return this.requestList;
      const flag = this.creditType === "head_hunting" ? 1 : 0;
      return this.requestList.filter((request) => Number(request.head_hunting) === flag);
    },
    totalCredits() {
      const total = this.filteredRequests.reduce((sum, request) => {
        return sum + request.credits;
      }, 0);
      return Math.round(total * 100) / 100;
    },
    ...mapGetters({
      requestList: "credit/paymentRequests",
      currentStaff: "credit/currentStaff",
    }),
  },
  mounted() {
    this.$nextTick(() => {
      if (this.staffId !== 0) {
        this.fetchRequests(this.staffId);

        const startDate = moment(this.startDate),
          endDate = moment(this.endDate);

        if (startDate.isValid() && endDate.isValid() && startDate.isBefore(endDate)) {
          this.range.start = startDate.format("YYYY-MM-DD");
          this.range.end = endDate.format("YYYY-MM-DD");
        }
      }
    });
  },
  methods: {
    updateDateRange(start, end) {
      this.range.start = start;
      this.range.end = end;

      this.fetchRequests(this.staffId);
    },
    fetchRequests(staffId) {
      if (staffId !== 0) {
        this.loadingRequests = true;
        this.$store.dispatch("credit/getPaymentRequests", { staffId: staffId, startDate: this.range.start, endDate: this.range.end }).then(() => {
          this.loadingRequests = false;
        });
      }
    },
  },
};
</script>

<style scoped>
.border-active {
  border-color: #153c4a !important;
}
</style>
